module.exports = __webpack_public_path__ + "img/O_illustration.c2b8ac7c.gif";